<template>
  <div>

    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <!-- Breadcrumb -->
      <app-breadcrumb />
      <b-row>
        <b-col md="12">
          <b-card aria-hidden="true">
            <!-- Alert: No item found -->
            <b-alert
              variant="danger"
              :show="errorMessage !== ''"
            >
              <h4 class="alert-heading">
                {{ errorMessage }}
              </h4>

            </b-alert>

            <!-- BODY -->
            <validation-observer
              #default="{ handleSubmit }"
              ref="refFormObserver"
            >
              <!-- Form -->
              <b-form
                class=""
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
              >
                <!--  Nội dung -->

                <validation-provider
                  #default="validationContext"
                  :name="$t('Nội dung')"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('Nội dung')"
                    label-for="title"
                  >
                    <template #label>
                      <label class="d-block font-weight-bolder">Nội dung mượn <span class="text-danger">*</span></label>
                    </template>
                    <b-form-textarea
                      id="content"
                      v-model="itemData.content"
                      :state="getValidationState(validationContext)"
                      rows="3"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <b-form-group
                  :label="$t('Nội dung')"
                  label-for="title"
                >
                  <template #label>
                    <label class="d-block font-weight-bolder">Lý do mượn mượn</label>
                  </template>
                  <b-form-textarea
                    id="reason"
                    v-model="itemData.reason"
                    rows="2"
                  />
                </b-form-group>

                <div class="row">
                  <div class="col-6">
                    <!-- Ngày mượn -->
                    <validation-provider
                      #default="validationContext"
                      :name="$t('Ngày mượn')"
                      rules="required"
                    >
                      <b-form-group
                        label="Ngày mượn"
                        label-for="borrow_begin_date"
                      >
                        <flat-pickr
                          v-model="itemData.borrow_begin_date"
                          class="form-control"
                          :config="configDate"
                          placeholder="dd-mm-yyyy"
                        />
                        <b-form-invalid-feedback :state="getValidationState(validationContext)">
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <div class="col-6">
                    <validation-provider
                      #default="validationContext"
                      :name="$t('Ngày dự kiến trả')"
                      rules="required"
                    >
                      <b-form-group
                        label="Ngày dự kiến trả"
                        label-for="plan_date"
                      >
                        <flat-pickr
                          v-model="itemData.plan_date"
                          class="form-control"
                          :config="configDate"
                          placeholder="dd-mm-yyyy"
                        />
                        <b-form-invalid-feedback :state="getValidationState(validationContext)">
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </div>
                  <div class="d-flex mt-2 col-12 justify-content-end w-100">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-info"
                      class="mb-2"
                      type="button"
                      @click="showDevie()"
                    >
                      <feather-icon icon="PlusCircleIcon" /> Thêm thiết bị
                    </b-button>
                  </div>

                  <div class="col-12 table-reponsive-sm">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Tên thiết bị</th>
                          <th>Series</th>
                          <th>Hành động</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>12</td>
                          <td>12</td>
                          <td>12</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Form Actions -->
                <div class="d-flex mt-2">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-2"
                    type="submit"
                  >
                    <span>{{ $t('Save') }}</span>
                  </b-button>
                </div>
              </b-form>
            </validation-observer>
          </b-card>

        </b-col>
      </b-row>
    </b-overlay>
    <b-modal
      id="formSearchDevice"
      body-class=" mb-2"
      size="xl"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      title="Danh sách thiết bị"
    >
      <form-search-device @handleSearchDevice="handleSearchDevice" />
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BOverlay, BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback,
  BFormTags, BTooltip, BInputGroupAppend, BFormTag, BInputGroup,
  BFormTextarea,
} from 'bootstrap-vue'
import {
  ref, watch,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNum, alphaNumDot, max, integer, positive,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'

import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import vSelect from 'vue-select'
import FormSearchDevice from './FormSearchDevice.vue';

function formatPrice(val) {
  const price = val.toString().replace(/,/g, '');
  return price;
}
export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    BFormTags,
    BTooltip,
    BInputGroupAppend,
    BInputGroup,
    BFormTag,
    vSelect,
    flatPickr,
    BFormTextarea,
    FormSearchDevice,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
      alphaNum,
      alphaNumDot,
      max,
      positive,

    }
  },
  methods: {
    showDevie() {
      this.$bvModal.show('formSearchDevice')
    },
    handleSearchDevice() {
      // console.log(!23);
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const layout = ref(route.value.name !== 'devices-edit' ? 'add' : 'edit');
    const loading = ref(!!id.value)
    const errorMessage = ref('')
    const devices = ref([])
    const defaultItemData = {
      name: '',
      category_type_device_id: null,
      country_id: null,
      manufacture_id: null,
      provider_id: null,
      model_id: null,
      buy_date: '',
      use_begin_date: '',
      warehouse_import_date: '',
      duration_warrantiry: '',
      price_original: '',
      depreciation_rates: '',
      department_id: null,
      manager_id: null,
      series: [],
      note: '',
    }
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)

    const onSubmit = () => {
      errorMessage.value = '';
      loading.value = true;

      const { price_original } = itemData.value;
      itemData.value.price_original = formatPrice(price_original)
      itemData.value.series = seriesName
      if (layout.value === 'edit') {
        store.dispatch('device/update', { id: id.value, data: itemData.value })
          .then((response) => {
            loading.value = false
            if (response.status === 200) {
              if (response.data.code === 200) {
                showToast(response.data.message, { variant: 'success' });
                router.push({ name: 'devices-list' })
              } else {
                showToast(response.data.message)
                errorMessage.value = response.data.message;
              }
            }
          })
      } else {
        store.dispatch('device/create', itemData.value)
          .then((response) => {
            loading.value = false
            if (response.status === 200) {
              if (response.data.code === 200) {
                showToast(response.data.message, { variant: 'success' });
                router.push({ name: 'devices-list' })
              } else {
                showToast(response.data.message)
                errorMessage.value = response.data.message;
              }
            }
          })
      }
    }

    const fetchData = () => {
      loading.value = true;
      store.dispatch('device/fetchOne', { id: id.value })
        .then(response => {
          if (response.status === 200) {
            itemData.value = response.data.data
            convertCurrency();
            seriesName.value = itemData.value.series.map(o => o.name);
            // seriesName.value = itemData.value.series.map(o => ({
            //   name: o.name,
            //   id: o.id,
            // }));

            loading.value = false
            errorMessage.value = '';
          } else {
            errorMessage.value = response.message
            loading.value = false
          }
        })
    }
    if (id.value && layout.value === 'edit') {
      fetchData();
    }

    watch(
      () => context.root.$route,
      (to) => {
        if (to.name === 'devices-add') {
          resetItemData();
        } else {
          fetchData();
        }
      },
    )
    const configDate = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });

    return {
      id,
      layout,
      errorMessage,
      loading,
      itemData,
      devices,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      fetchData,
      configDate,
    }
  },

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
